<template>
  <v-select
    :value="value"
    @input="$emit('input', $event)"
    v-bind="$attrs"
    v-on="$listeners"
    :label="label"
    :items="listItems"
    :readonly="readonly"
    :item-value="valueName"
    item-text="Text"
    dense
    outlined
    :rules="rules"
    :disabled="disabled"
  >
  </v-select>
</template>
<script>
export default {
  props: {
    value: { type: [String, Number] },
    label: { type: String },
    listItems: { type: Array },
    readonly: { type: Boolean },
    rules: { type: Array },
    disabled: { type: Boolean },
    valueName: {type: String},
    
  },
  data: () => ({}),
};
</script>
<style>
.v-list-item__title {
  text-align: left !important;
}
</style>
